<div class="row text-center mt-3 justify-content-center paymentsContaienr">
  <a (click)="payByPaypal()" class="payment-method-link" *ngIf="isPaypalCountry(countryName)">
    <img src="../../../../assets/img/png/paypal.png" alt="paypal" id="paypal" class="payment-method-img">
    <div class="paymentText" id="textPaypal">{{'shipping.pay' | translate}}</div>
  </a>
  <a (click)="payByPayU()" class="payment-method-link" *ngIf="countryName == 'Colombia'">
    <img src="../../../../assets/img/png/payu.png" alt="payu" id="payu" class="payment-method-img pay-u">
    <div class="paymentText" id="textPayu">{{'shipping.pay' | translate}}</div>
  </a>
</div>  